// A17 incident management — module-local data layer. REAL backend (deployed):
//   /admin/incidents (list/create), /admin/incidents/:id (card+timeline),
//   /admin/incidents/:id/update, /admin/incidents/:id/resolve, /admin/oncall.
// HOT fayllarga tegmaydi.
import { api } from '@/lib/api'

export interface IncidentUpdate {
  note: string
  status: string
  created_by: string
  created_at: string
}
export interface IncidentRow {
  id: number
  title: string
  severity: string
  status: string
  summary: string
  started_at: string
  resolved_at: string | null
  created_by: string
}
export interface IncidentDetail extends IncidentRow {
  root_cause: string
  action_items: string
  updates: IncidentUpdate[]
}
export interface OnCallShift {
  id: number
  admin: string
  role: string
  starts_at: string
  ends_at: string
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchIncidents = (status = '', s?: AbortSignal) =>
  api
    .get<{ incidents: IncidentRow[] }>('/admin/incidents', {
      query: status ? { status } : {},
      ...(s ? { signal: s } : {}),
    })
    .then((d) => d.incidents ?? [])
export const fetchIncident = (id: number, s?: AbortSignal) =>
  api.get<{ incident: IncidentDetail }>(`/admin/incidents/${id}`, opt(s)).then((d) => d.incident)
export const createIncident = (title: string, severity: string, summary: string) =>
  api.post<{ id: number }>('/admin/incidents', { title, severity, summary })
export const addIncidentUpdate = (id: number, note: string, status: string) =>
  api.post(`/admin/incidents/${id}/update`, { note, status })
export const resolveIncident = (id: number, root_cause: string, action_items: string) =>
  api.post(`/admin/incidents/${id}/resolve`, { root_cause, action_items })

export const fetchOnCall = (s?: AbortSignal) =>
  api.get<{ shifts: OnCallShift[] }>('/admin/oncall', opt(s)).then((d) => d.shifts ?? [])
export const addOnCall = (role: string, starts_at: string, ends_at: string) =>
  api.post<{ id: number }>('/admin/oncall', { role, starts_at, ends_at })
export const deleteOnCall = (id: number) => api.del(`/admin/oncall/${id}`)

export const SEVERITIES = ['sev1', 'sev2', 'sev3', 'sev4'] as const
export const STATUSES = ['open', 'investigating', 'monitoring', 'resolved'] as const

export const SEV_LABEL: Record<string, string> = {
  sev1: 'SEV1 · критично',
  sev2: 'SEV2 · высокий',
  sev3: 'SEV3 · средний',
  sev4: 'SEV4 · низкий',
}
export const STATUS_LABEL: Record<string, string> = {
  open: 'Открыт',
  investigating: 'Расследуется',
  monitoring: 'Наблюдение',
  resolved: 'Решён',
}

export const INC_STR = {
  incidents: 'Инциденты',
  incidentsDesc: 'Регистрация, хронология и разбор инцидентов',
  oncall: 'График дежурств (on-call)',
  oncallDesc: 'Кто на дежурстве',
  create: 'Создать инцидент',
  title: 'Заголовок',
  severity: 'Уровень',
  summary: 'Описание',
  status: 'Статус',
  started: 'Начат',
  resolved: 'Решён',
  timeline: 'Хронология',
  addUpdate: 'Добавить запись',
  note: 'Запись',
  resolveBtn: 'Закрыть (постмортем)',
  rootCause: 'Первопричина',
  actionItems: 'Действия',
  postmortem: 'Постмортем',
  role: 'Роль',
  primary: 'Основной',
  secondary: 'Запасной',
  from: 'С',
  to: 'По',
  add: 'Добавить',
  delete: 'Удалить',
  save: 'Сохранить',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет инцидентов',
  emptyOncall: 'Нет дежурств',
  select: 'Выберите инцидент',
  refresh: 'Обновить',
  cancel: 'Отмена',
} as const
